import { render, staticRenderFns } from "./BookingQuestionRow.vue?vue&type=template&id=631c39b5"
import script from "./BookingQuestionRow.vue?vue&type=script&lang=js"
export * from "./BookingQuestionRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports